// extracted by mini-css-extract-plugin
export default {"no_data":"style_no_data__q6f9n"};